import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import * as queueApi from "../../api/queueApi";
import { sessionError, setSessionCode } from "../../actions/sessionActions";
import { loadHostProfile } from "../../actions/hostActions";
import { isValidSessionCode, normalizeSessionCode } from "../../config";
import { setHostToken } from "../../session/hostTokens";
import { setHostKey } from "../../session/hostKey";
import { hasSessionCache } from "../../offline/sessionCache";

/**
 * Handles share links of the form https://sing.at/ABCDE by joining that session. A host
 * link (https://sing.at/ABCDE?key=<host key>, or the older ?host=<token>) also makes this
 * browser the session's host.
 */
const JoinByCodePage = () => {
  const { code } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const sessionCode = normalizeSessionCode(code);
  const hostToken = searchParams.get("host");
  const hostKey = searchParams.get("key");

  useEffect(() => {
    let cancelled = false;

    const join = async () => {
      if (!isValidSessionCode(sessionCode)) {
        navigate("/", { replace: true });
        return;
      }
      if (hostToken) setHostToken(sessionCode, hostToken);
      if (hostKey && setHostKey(hostKey)) {
        // the join below then runs as that host; the server confirms (or drops) the key
        dispatch(loadHostProfile());
      }
      try {
        await queueApi.getQueue(sessionCode);
        if (cancelled) return;
        dispatch(setSessionCode(sessionCode));
        navigate("/lyrics", { replace: true });
      } catch (err) {
        if (cancelled) return;
        if (!err.response && hasSessionCache(sessionCode)) {
          dispatch(setSessionCode(sessionCode));
          navigate("/lyrics", { replace: true });
          return;
        }
        dispatch(
          sessionError(
            err.response?.status === 404
              ? `No session with code ${sessionCode}`
              : "Could not reach the server, please try again"
          )
        );
        navigate("/", { replace: true });
      }
    };

    join();
    return () => {
      cancelled = true;
    };
  }, [sessionCode, hostToken, hostKey, dispatch, navigate]);

  return (
    <div className="start">
      <div>
        <div className="start-brand">Sing At</div>
        <div className="start-tag">{sessionCode}</div>
      </div>
      <div className="start-body">
        <p className="muted">Joining session…</p>
      </div>
    </div>
  );
};

export default JoinByCodePage;
